export default __webpack_public_path__ + "static/media/xlsx.178cbc93.svg";